import React from 'react';

import PropTypes from 'prop-types';

import './Drawer.css';

const Drawer = ({
  isOpen,
  children,
  onClose
}) => {
  return (
    isOpen && (
      <div
        className="bottom-drawer-overlay"
        onClick={onClose}>

        <div
          className="bottom-drawer"
          onClick={(e) => e.stopPropagation()}>

          <button
            className="bottom-drawer-close-button"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            x Close
          </button>
          <div className='bottom-container'>
            {children}
          </div>
        </div>
      </div>
    )
  );
};

Drawer.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func
};

export default Drawer;